export class Scale {
    static getFrom(origin: { width: number, height: number }, current: { width: number, height: number }): Scale {
        return new Scale(
            current.width / origin.width,
            current.height / origin.height
        );
    }

    constructor(readonly x: number = 1.0, readonly y: number = 1.0) {
    }

    get widthFactor(): number {
        return this.x;
    }

    get heightFactor(): number {
        return this.y;
    }

    get avereage(): number {
        return (this.x + this.y) / 2;
    }

    get min(): number {
        return Math.min(this.x, this.y);
    }

    get max(): number {
        return Math.max(this.x, this.y);
    }
}



// WEBPACK FOOTER //
// ./src/shared/xp/geom/Scale.ts